/*
 * @Author: chenjx
 * @Date: 2023-02-24 15:11:02
 * @LastEditors: chenjx
 * @LastEditTime: 2023-03-05 19:56:55
 * @Description: file content
 * @FilePath: \aitesi\src\main.js
 */
import Vue from 'vue'
import { Pagination, Message, Icon } from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue'
import router from './router'
import http from './http'
import store from './store'

Vue.prototype.$http = http
Vue.prototype.$message = Message
Vue.config.productionTip = false
Vue.use(Pagination)
Vue.use(Icon)


const app = new Vue({
  router,
  store,
  render: h => h(App),
})
app.$mount('#app')
